import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getToken } from '../helpers/Token';
import callrecorderUrls from "../configs/callrecorder/callrecorderUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const callrecorderApi: ApiInterface = axios.create({ baseURL: callrecorderUrls.baseURL })
callrecorderApi.interceptors.request.use(onRequest);

callrecorderApi.oneSky = {
  url: callrecorderUrls.remoteUrl.bind(callrecorderUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default callrecorderApi;
